module.exports = __webpack_public_path__ + "static/img/card3.abc786b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card3.png
// module id = mdGw
// module chunks = 2